export const CLOSE_EDIT_LICENSING_OPTIONS_MENU_EVENT = 'closeEditLicensingOptionsMenuEvent';
